//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SIM.PostConfigurator.js";
import "../no/Builder.js";
import "../SIM/SIM.PostConfigurator.UdeParameterBuilderList.js";
import "../no/SIM.js";
import "../no/ObjectList.js";
let d=[[[0,"CdlWrite",1,0],[0,"EventCategoryDrilling",1,0],[0,"EventCategoryInvalid",1,0],[0,"EventCategoryMilling",1,0],[0,"EventCategoryTurning",1,0],[0,"EventCategoryWireEDM",1,0],[0,"EventDescription",1,0],[0,"EventHelpDescription",1,0],[0,"EventHelpLocation",1,0],[0,"EventID",1,0],[0,"EventName",1,0],[0,"PostEvent",1,0],[1,"UdeParameterList",0,"SIM.PostConfigurator.UdeParameterBuilderList",0]],[[["itemBuilder"],"AddItem",{},1,0],[["itemBuilder"],"DeleteItem",{},1,0],[[],"DeleteItems",{},0,0],[["parameterID"],"GetUdeParameterBuilder",{R_:{itemBuilder:"SIM.PostConfigurator.UdeParameterBuilder"}},1,0],[["itemBuilder","oldParameterID","newParameterID"],"RenameParameterID",{},3,0]],[]];
SPLM.SIM.PostConfigurator.UdeBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SIM.PostConfigurator.UdeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SIM.PostConfigurator.UdeBuilder.EventDescriptionType = Object.freeze({
    "None" : "None", "Specify" : "Specify"});

SPLM.SIM.PostConfigurator.UdeBuilder.CdlWriteType = Object.freeze({
    "Event" : "Event", "Cycle" : "Cycle", "SysCycle" : "SysCycle"});

export default SPLM;